import axios  from "axios";
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

// export const  fetch_datumfeedback = (datumID, userID) => API.get(`/datum/fetchfeedback/${datumID}/${userID}`,{datumID:datumID, userID:userID})
API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const fetch_datumfeedback = async (datumID, userID) => {
    const response = await API.get(`/datum/fetchfeedback/${datumID}/${userID}`);
    return response.data; // Ensure this returns the correct structure
};

export const  save_datumfeedback = (feedbacktype, datumID, userID, sessionId) => API.put(`/datum/savefeedback/${feedbacktype}/${datumID}/${userID}`,{feedbacktype:feedbacktype,datumID:datumID, userID:userID, sessionId})